<template>
  <div class="home py-5">
		<span class="d-flex flex-row page-title">{{$t("intranet.title.page.wineComments.list")}}</span>
    <div v-if="dataLoaded" class="form-container">
      <AveineWineCommentValidation :APIbaseURL="APIbaseURL" :wineUserComments="wineUserComments" :adminMode="true"/>
      <div class="text-center">
        <v-pagination
          v-model="currentPage"
          :length="paginationLength"
          :total-visible="paginationLength < 7 ? paginationLength : 7"
        ></v-pagination>
      </div>
    </div>
    <div v-else class="d-flex justify-center align-center mt-16">
      <v-progress-circular
        indeterminate
        :size="100"
        :width="10"
        color="secondary"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { AveineWineCommentValidation } from 'aveine-wine'
import { WineUserComment } from 'aveine-toolbox'
import { errorHandler } from 'aveine-toolbox'
export default {
  data () {
    return {
      wineUserComments: [],
      currentPage: this.$route.query.page,
      paginationLength: 0,
      dataLoaded: false,
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  name: 'Validation',
  components: {
    AveineWineCommentValidation
  },
  async beforeCreate() {
    try {
      let wineUserComments = await WineUserComment.api().get(`wine-user-comments?lang=${this.$i18n.locale}`, {
          params: {
          include: 'user.profile,' +
          'wine.template.appellation,' +
          'wine.template.region,' +
          'wine.template.country,' +
          'wine.template.domain.region.country,' +
          'wine.wine-labels,' +
          'wine.appellation',
          "filter[state]": "pending",
          sort: "created-at",
          page: {
            number: this.$route.params.page || 1,
            size: 50
          },
          }
        }
      );
      wineUserComments.response.data.map(async (comment) => {
        let wineComment = await WineUserComment.query().whereId(comment.id).withAllRecursive().first();

          let template = wineComment.wine.template;
          wineComment.wine.designation = template.designation;
          wineComment.wine.color = template.color;
          wineComment.wine.domain = template.domain;
          wineComment.wine.region = template.region;
          wineComment.wine.country = template.country;
          this.wineUserComments.push(wineComment)
      });
      this.dataLoaded = true;
    } catch (errors) {
      this.dataLoaded = true;
      errorHandler(errors, this)
    }
  }
}
</script>
